export default {
  recommendationTitle: {
    id: 'recommendation_cross_sell_accessories_title',
    defaultMessage: 'Make it last (even longer)',
  },
}
